<ul class="navbar-nav" role="menu">
  <ng-container *ngFor="let item of menu; let i = index">
    <li class="nav-item position-relative">
      <ng-container *ngIf="item.submenus; else menuTemplate">
        <a
          [id]="'menu-item-' + i"
          class="nav-link dropdown-toggle"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          [attr.tabindex]="0">
          {{ item.title }}
          <fa-icon [icon]="faChevronDown" class="fs-6 ms-3"></fa-icon>
        </a>

        <ul class="dropdown-menu" role="menu">
          <ng-container *ngFor="let submenu of item.submenus; let idx = index">
            <li role="menuitem">
              <a
                [id]="'submenu-item-' + idx"
                class="dropdown-item"
                (click)="redirectTo(submenu)"
                (keyup.enter)="redirectTo(submenu)"
                [attr.tabindex]="0"
                >{{ submenu.title }}</a
              >
            </li>
          </ng-container>
        </ul>
      </ng-container>

      <ng-template #menuTemplate>
        <a
          class="nav-link"
          role="button"
          aria-current="page"
          (click)="redirectTo(item)"
          (keyup.enter)="redirectTo(item)"
          [attr.tabindex]="0"
          >{{ item.title }}
          @if (item?.additionalTitle) {
            <span class="text-capitalize">
              {{ item.additionalTitle }}
            </span>
          }
        </a>
      </ng-template>
    </li>
  </ng-container>
</ul>
